import { withInstall } from '../../utils/install';

import Upload from './index.vue';

export const IvueUpload = withInstall(Upload);
export default IvueUpload;

export * from './index.vue';
